import React, { FC, useState } from 'react';
import { Modal, Text, ButtonGroup, Button, Checkbox, Link } from '@nike/eds';
import { useI18nContext } from 'context/language/use-i18n-context';
import ts from './i18n';
import { ModalData } from '../Type';
import { useLanguageContext } from 'context/language/context';
import { Languages } from 'models/translations';

type Props = {
  modalData: ModalData;
  handleAction: (id: number, actionType: 'cancel' | 'approve' | 'decline') => void;
};

export const ApproveModal: FC<Props> = ({ modalData, handleAction }) => {
  const { i18nString } = useI18nContext();
  const [vendorCheck, setVendorCheck] = useState(false);
  const [language] = useLanguageContext();

  const vendorAgreement = (
    <div data-testid="legalText" className="eds-spacing--mb-16 eds-type--legal-1">
      {language !== Languages.ZH ? (
        <Text data-testid="legalText-En">
          * It is against NIKE policy to approve a Vendor pass meant for the benefit of a government
          official, a government organization, a state owned entity or any person working in such
          Government organization or state owned entity. By approving the Vendor pass you confirm
          having read, understood and complied with the
          <Link href="https://nike.sharepoint.com/teams/ap5/NikeGCLegal/PublishingImages/Lists/PoliciesList/EditForm/Mainland%20China%20Rider%20on%20Government%20Officials%20Gifts%20and%20Hospitality%20-%20EN.PDF">
            {' '}
            Mainland China Rider to &quot;Government Official&quot; Gifts and Hospitality Policy
          </Link>
          . Please contact{' '}
          <Link href="mailto:GC.ECO@NIKE.COM">Legal Compliance Ethics &amp; Compliance Office</Link>
          , if you have any questions or concerns.
        </Text>
      ) : (
        <Text data-testid="legalText-zh">
          *
          公司政策禁止将供应商通行证发放给政府官员或在政府机构及国有企业内任职的员工，批准该供应商通行证的申请表明你确认你已阅读、理解并遵守公司《
          <Link href="https://nike.sharepoint.com/teams/ap5/NikeGCLegal/PublishingImages/Lists/PoliciesList/EditForm/Mainland%20China%20Rider%20on%20Government%20Officials%20Gifts%20and%20Hospitality%20-%20CN.PDF">
            {' '}
            中国大陆&quot;政府官员&quot;礼品及费用政策
          </Link>
          》的规定。 如有任何疑问或顾虑，请联系
          <Link href="mailto:GC.ECO@NIKE.COM">道德与合规办公室</Link>。
        </Text>
      )}
    </div>
  );

  const header = (
    <Text as={'h3'} className="txt-align-center txt_uppercase">
      {i18nString(
        modalData.modalType == 'approve'
          ? ts.APPROVAL_APPROVE_REQUEST
          : ts.APPROVAL_DECLINE_REQUEST,
      )}
    </Text>
  );

  const footer = (
    <>
      <div>
        {modalData.isChinaVendor && (
          <Checkbox
            data-testid="legalCheckbox"
            id="vendorCheck"
            name="Jordan"
            label={vendorAgreement}
            onClick={prev => setVendorCheck(!prev)}
          />
        )}
      </div>
      <ButtonGroup>
        <Button
          data-testid="cancelButton"
          onClick={() => handleAction(modalData.id, 'cancel')}
          size="small"
        >
          {i18nString(ts.APPROVAL_CANCEL)}
        </Button>
        <Button
          data-testid="approveButton"
          size="small"
          variant="secondary"
          disabled={modalData.modalType == 'approve' && modalData.isChinaVendor && !vendorCheck}
          onClick={() =>
            handleAction(modalData.id, modalData.modalType == 'approve' ? 'approve' : 'decline')
          }
        >
          {i18nString(modalData.modalType == 'approve' ? ts.APPROVAL_APPROVE : ts.APPROVAL_DECLINE)}
        </Button>
      </ButtonGroup>
    </>
  );

  return (
    <Modal
      onDismiss={() => handleAction(modalData.id, 'cancel')}
      isOpen={modalData.open}
      headerSlot={header}
      footerSlot={footer}
    >
      <div>
        <Text className="eds-type--body-3 txt_uppercase" as={'p'}>
          {i18nString(ts.APPROVAL_YOUR_EMPLOYEE)}
          <span className="txt-green txt_uppercase">{' ' + modalData.name + ' '}</span>
          {i18nString(ts.APPROVAL_YOUR_EMPLOYEE_NOTIFIED)}
        </Text>
      </div>
    </Modal>
  );
};

export default ApproveModal;
